import React from 'react'
import AIonCampusWideBannerURL from '../../assets/banners/AIonCampusBanner-big.png';
import AIonCampusWideBannerMobileURL from '../../assets/banners/AIonCampusBannerSquare-big.png';

const WideImg2 = () => {

    return (
        <div className='w-screen px-4 py-12 lg:py-20 md:px-8 xl:px-[4vw] bg-brand-black'>
            <img src={AIonCampusWideBannerURL} className="hidden sm:block w-full rounded-md" alt="AI on campus Wide Banner" />
            <img src={AIonCampusWideBannerMobileURL} className="sm:hidden w-full rounded-md" alt="AI on campus Wide Banner Mobile" />
        </div>
    )
}

export default WideImg2